import LandingPage from "./view/LandingPage";
import { HashRouter } from "react-router-dom";
import Root from "./utils/Root";


function App() {

  return (
      <HashRouter>
          <LandingPage />
          <Root />
      </HashRouter>
  );
}
export default App;